module.exports = __webpack_public_path__ + "img/plaisance.04319162.jpg";